import { render, staticRenderFns } from "./ownerdeductionruleAction.vue?vue&type=template&id=3bf056fe&scoped=true"
import script from "./ownerdeductionruleAction.vue?vue&type=script&lang=js"
export * from "./ownerdeductionruleAction.vue?vue&type=script&lang=js"
import style0 from "./ownerdeductionruleAction.vue?vue&type=style&index=0&id=3bf056fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bf056fe",
  null
  
)

export default component.exports